import apiClient from './client';

export interface RealtimeTicketResponse {
  ticket: string;
  expiresAt: string;
}

export const realtimeApi = {
  issueTicket: async () =>
    (await apiClient.post<RealtimeTicketResponse>(
      '/realtime/ticket'
    )) as unknown as RealtimeTicketResponse,
};
